import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#003049",
    },
    secondary: {
      main: "#d67d3e",
    },
    warning: {
      main: "#F1C535",
    },
  },
});
